<template>
<modal :show="show">
	<Loader :loading="loading" ref="loader"></Loader>
    <div class="modal-header">
        <h5 class="modal-title">Kolkin Investor</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body">

		<label>Enter your email and a sign-in link will be sent to your inbox</label>
        <input @keydown.enter="confirm" v-model="email" type="email">
		
    </div>

    <div class="modal-footer">
		<button class="confirm-button" @click="confirm">
            Submit
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
import Loader from "@/../submodules/vue-base/components/Loader";
import axios from "axios";
export default {

    name: 'RequestSigninModal',

    components: {
        Modal,
		Loader
    },

    data(){
        return {
            show:false,
			loading: false,
			email: ""
        }
    },

    methods: {
        open(){
            this.show=true;
			this.email = "";
        },

        close(){
            this.show=false
        },

        confirm() {
			
			this.loading = true;
			var temp = this;
			axios.post("/api/signin/user",{email:this.email,next:"/investor/investments"}).then(function(response){

				temp.loading=false;

				temp.$emit("confirm");
            	temp.close();

			}).catch(function(){
				
				temp.loading=false;
				temp.$emit("error");
				temp.close();

			})

            
        }
    }

}
</script>
